module.exports = __webpack_public_path__ + "img/spa_logo.8283e9e7.png";